(function () {
    'use strict';
    var message = {
        success: {},
        warning: {},
        error: {},
        formValidation: {}
    }
    var commonConstant = {
        currencyRegex: /^\d+(?:\.?\d{0,3})$/,
        email: "^(([^<>()\\[\\]\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"
    };
    var generalTaskConstant = {
        menus: ['Labor', 'Materials', 'Equipment'],
        material_menu: ['Inventory Materials']
    };
    var csvExportConstant = {
        supplierMaterial: ['Name', 'Category', 'Supplier', 'Price/Order', 'Delivery Price'
            , 'Usage Rate', 'Unit of Usage', 'Days Offset', 'Bulk Quantity', 'Bulk Price', 'Inventory'],
        inventoryMaterial: ['Name', 'Category', 'Supplier', 'Price/Order', 'Delivery Price'
            , 'Usage Rate', 'Unit of Usage', 'Days Offset', 'Bulk Quantity', 'Bulk Price', 'Inventory']
    };

    var accountingConstant = {
        totalIdleTime: 300,
        timeoutTime: 15,
        idleTime: 285,
        accountType: [
            { 'name': 'Assets', 'type': [
                { 'name': 'Current Assets', 'type': [
                    { 'name': 'Account Receivable', 'parent': 'Current Assets', 'parentOfParent': 'Assets', 'detailType': ['Account Receivable'] },
                    { 'name': 'Bank', 'parent': 'Current Assets', 'parentOfParent': 'Assets', 'detailType':['Cash On Hand', 'Checking', 'Money Market', 'Rent Held In Trust', 'Saving', 'Trust Account'] },
                    { 'name': 'Other Current Assets', 'parent': 'Current Assets', 'parentOfParent': 'Assets', 'detailType': ['Allowance for bed debts', 'Development Cost', 'Employee Cash Advance', 'Inventory', 'Investment-Mortgage/Real Estate Loans', 'Investment-Taxed Exempt Securities', 'Investment-Us Govt. Obligations', 'Investment-Others', 'Loans To Officers', 'Loans To Others', 'Loans To Stockholders', 'Other Current Assets', 'Pre-paid Expenses', 'Retainage', 'Undeposited Funds'] }
                ]},
                { 'name': 'Fixed Assets', 'type': [
                    { 'name': 'Fixed Assets', 'parent': 'Fixed Assets', 'parentOfParent': 'Assets', 'detailType': ['Accumulated Ammortization', 'Accumulated Depreciation', 'Buildings', 'Depleted Assets', 'Fixed Assets Computers', 'Fixed Assets Copiers', 'Fixed Assets Furniture', 'Fixed Assets Other Tools Equipment', 'Fixed Assets Phone', 'Fixed Assets Photo Video', 'Fixed Assets Software', 'Furniture and Fixtures', 'Intangible Assets', 'Land', 'Leasehold Improvements', 'Machinery & Equipment', 'Other Fixed Assets', 'Vehicles'] },
                    { 'name': 'Other Assets', 'parent': 'Fixed Assets', 'parentOfParent': 'Assets', 'detailType': ['Accumulated Amortization of Other Assets', 'Goodwill', 'Lease Buyouts', 'Licenses', 'Orginizational Costs', 'Other Long-term Assets', 'Security Deposits']}
                ]}
            ]},
            { 'name': 'Liabilities', 'type': [
                { 'name': 'Current Liabilities', 'type': [
                    { 'name': 'Accounts Payable', 'parent': 'Current Liabilities', 'parentOfParent': 'Liabilities', 'detailType': ['Accounts Payable'] },
                    { 'name': 'Credit Card', 'parent': 'Current Liabilities', 'parentOfParent': 'Liabilities', 'detailType': ['Credit Card'] },
                    { 'name': 'Other Current Liabilities', 'parent': 'Current Liabilities', 'parentOfParent': 'Liabilities', 'detailType': ['Federal Income Tax Payable', 'Insurance Payable', 'Line Of Credit', 'Loan Payable', 'Other Current Liabilities', 'Payroll Clearing', 'Payroll Tax Payable', 'Prepaid Expenses Payable', 'Rent In Trust – Liability', 'Sales Tax Payable', 'State/Local Income Tax Payable', 'Trust Accounts – Liabilities', 'Undistributed Tips']}
                ]},
                { 'name': 'Long Term Liabilities', 'type': [
                    { 'name': 'Long Term Liabilities', 'parent': 'Long Term Liabilities', 'parentOfParent': 'Liabilities', 'detailType': ['Notes Payable', 'Other Long Term Liabilities', 'Shareholder Notes Payable']}
                ]}
            ]},
            { 'name': 'Equity', 'type': [
                { 'name': 'Equity', 'parent': 'Equity', 'parentOfParent': '', 'detailType': ['Accumulated Adjustment', 'Common Stock', 'Estimated Taxes', 'Healthcare', 'Opening Balance Equity', 'Owner’s Equity', 'Paid-in Capital or Surplus', 'Partner Contributions', 'Partner Distributions', 'Partners Equity', 'Personal Expense', 'Personal Income', 'Preferred Stock', 'Retained Earnings', 'Treasury Stock']}
            ]},
            { 'name': 'Income', 'type': [
                { 'name': 'Income', 'parent': 'Income', 'parentOfParent': '', 'detailType': ['Discounts/Refunds Given', 'Non-Profit Income', 'Other Primary Income', 'Sales Product Income', 'Service/Fee Income', 'Unapplied Cash Payment Income'] },
                { 'name': 'Other Income', 'parent': 'Income', 'parentOfParent': '', 'detailType': ['Dividend Income', 'Interest Earned', 'Other Investment Income', 'Other Miscellaneous Income', 'Tax-Exemot Interest']}
            ]},
            { 'name': 'Expenses', 'type': [
                { 'name': 'Cost Of Goods Sold', 'parent': 'Expenses', 'parentOfParent': '', 'detailType': ['Equipment-COGS', 'Labor-COGS', 'Material-COGS', 'Field Employees Workers Comp–COGS', 'Field Employees Payroll Taxes-COGS', 'Other Costs of Services', 'Shipping, Freight & Delivery']},
                { 'name': 'Expenses', 'parent': 'Expenses', 'parentOfParent': '', 'detailType': ['Advertising/Promotional', 'Auto', 'Bad Debts', 'Bank Charges', 'Charitable Contributions', 'Cost of Labor', 'Dues & Subscriptions', 'Entertainment', 'Entertainment Meals', 'Equipment Rental', 'Finance Costs', 'Insurance', 'Interest Paid', 'Legal & Professional Fees', 'Office/General Administrative Expenses', 'Other Business Expenses', 'Other Miscellaneous Service Costs', 'Payroll Expenses', 'Promotional Meals', 'Rent or Lease of Buildings', 'Repair or Maintenance', "Shipping, Freight, Delivery's", 'Supplies & Materials', 'Taxes Paid', 'Travel', 'Travel Meals', 'Unapplied Cash Bill Payment Expense', 'Utilities']},
                { 'name': 'Other Expenses', 'parent': 'Expenses', 'parentOfParent': '', 'detailType': ['Ammortization', 'Depreciation', 'Exchange Gain or Loss', 'Gas or Fuel', 'Home Office', 'Homeowner Rental Insurance', 'Mortgage Interest Home Office', 'Other Home Office Expenses', 'Other Miscellaneous Expenses', 'Other Vehicle Expenses', 'Parking and Tolls', 'Penalties and Settlements', 'Rent and Lease Home Office', 'Repairs and Maintenance Home Office', 'Utilities Home Office', 'Vehicle', 'Vehicle Insurance', 'Vehicle Lease', 'Vehicle Loan', 'Vehicle Loan Interest', 'Vehicle Registration', 'Vehicle Repairs', 'Wash and Road Services']}
            ]}
        ],
        balanceSheets: [
            {
                name: 'Assets', balance: 0.00, pBalance: 0.00, childs: [
                    {
                        'name': 'Current Assets',
                        'types': [
                            {
                                'name': 'Account Receivable',
                                'detailType': ['Account Receivable'],
                                'charts': []
                            },
                            {
                                'name': 'Bank',
                                'detailType': ['Cash On Hand', 'Checking', 'Money Market', 'Rent Held In Trust', 'Saving', 'Trust Account'],
                                'charts': []
                            },
                            {
                                'name': 'Other Current Assets',
                                'detailType': ['Allowance for bed debts', 'Development Cost', 'Employee Cash Advance', 'Inventory', 'Investment-Mortgage/Real Estate Loans', 'Investment-Taxed Exempt Securities', 'Investment-Us Govt. Obligations', 'Investment-Others', 'Loans To Officers', 'Loans To Others', 'Loans To Stockholders', 'Other Current Assets', 'Pre-paid Expenses', 'Retainage', 'Undeposited Funds'],
                                'charts': []
                            }
                        ]
                    },
                    {
                        'name': 'Fixed Assets',
                        'types': [
                            {
                                'name': 'Fixed Assets',
                                'detailType': ['Accumulated Ammortization', 'Accumulated Depreciation', 'Buildings', 'Depleted Assets', 'Fixed Assets Computers', 'Fixed Assets Copiers', 'Fixed Assets Furniture', 'Fixed Assets Other Tools Equipment', 'Fixed Assets Phone', 'Fixed Assets Photo Video', 'Fixed Assets Software', 'Furniture and Fixtures', 'Intangible Assets', 'Land', 'Leasehold Improvements', 'Machinery & Equipment', 'Other Fixed Assets', 'Vehicles'],
                                'charts': []
                            },
                            {
                                'name': 'Other Assets',
                                'detailType': ['Accumulated Amortization of Other Assets', 'Goodwill', 'Lease Buyouts', 'Licenses', 'Orginizational Costs', 'Other Long-term Assets', 'Security Deposits'],
                                'charts': []
                            }
                        ]
                    }
                ]
            },
            {
                name: 'Liabilities & Equity', balance: 0.00, pBalance: 0.00, childs: [
                    {
                        'name': 'Liabilities', 'types': [
                            {
                                'name': 'Current Liabilities', 'types': [
                                    {
                                        'name': 'Accounts Payable',
                                        'detailType': ['Accounts Payable'],
                                        'charts': []
                                    },
                                    {
                                        'name': 'Credit Card',
                                        'detailType': ['Credit Card'],
                                        'charts': []
                                    },
                                    {
                                        'name': 'Other Current Liabilities',
                                        'detailType': ['Federal Income Tax Payable', 'Insurance Payable', 'Line Of Credit', 'Loan Payable', 'Other Current Liabilities', 'Payroll Clearing', 'Payroll Tax Payable', 'Prepaid Expenses Payable', 'Rent In Trust – Liability', 'Sales Tax Payable', 'State/Local Income Tax Payable', 'Trust Accounts – Liabilities', 'Undistributed Tips'],
                                        'charts': []
                                    }]
                            },
                            {
                                'name': 'Long Term Liabilities', 'types': [
                                    {
                                        'name': 'Long Term Liabilities',
                                        'detailType': ['Notes Payable', 'Other Long Term Liabilities', 'Shareholder Notes Payable'],
                                        'charts': []
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        'name': 'Equity', 'types': [
                            {
                                'name': 'Equity',
                                'detailType': ['Accumulated Adjustment', 'Common Stock', 'Estimated Taxes', 'Healthcare', 'Opening Balance Equity', 'Owner’s Equity', 'Paid-in Capital or Surplus', 'Partner Contributions', 'Partner Distributions', 'Partners Equity', 'Personal Expense', 'Personal Income', 'Preferred Stock', 'Retained Earnings', 'Treasury Stock'],
                                'charts': []
                            }
                        ]
                    }
                ]
            }
        ],
        balanceTypes: [
            'Account Receivable',
            'Cash On Hand',
            'Checking',
            'Money Market',
            'Rent Held In Trust',
            'Saving',
            'Trust Account',
            'Allowance for bed debts',
            'Development Cost',
            'Employee Cash Advance',
            'Inventory',
            'Investment-Mortgage/Real Estate Loans',
            'Investment-Taxed Exempt Securities',
            'Investment-Us Govt. Obligations',
            'Investment-Others',
            'Loans To Officers',
            'Loans To Others',
            'Loans To Stockholders',
            'Other Current Assets',
            'Pre-paid Expenses',
            'Retainage',
            'Undeposited Funds',
            'Accumulated Ammortization',
            'Accumulated Depreciation',
            'Buildings',
            'Depleted Assets',
            'Fixed Assets Computers',
            'Fixed Assets Copiers',
            'Fixed Assets Furniture',
            'Fixed Assets Other Tools Equipment',
            'Fixed Assets Phone',
            'Fixed Assets Photo Video',
            'Fixed Assets Software',
            'Furniture and Fixtures',
            'Intangible Assets',
            'Land',
            'Leasehold Improvements',
            'Machinery & Equipment',
            'Other Fixed Assets',
            'Vehicles',
            'Accumulated Amortization of Other Assets',
            'Goodwill',
            'Lease Buyouts',
            'Licenses',
            'Orginizational Costs',
            'Other Long-term Assets',
            'Security Deposits',
            'Accounts Payable',
            'Credit Card',
            'Federal Income Tax Payable',
            'Insurance Payable',
            'Line Of Credit',
            'Loan Payable',
            'Other Current Liabilities',
            'Payroll Clearing',
            'Payroll Tax Payable',
            'Prepaid Expenses Payable',
            'Rent In Trust – Liability',
            'Sales Tax Payable',
            'State/Local Income Tax Payable',
            'Trust Accounts – Liabilities',
            'Undistributed Tips',
            'Notes Payable',
            'Other Long Term Liabilities',
            'Shareholder Notes Payable',
            'Accumulated Adjustment',
            'Common Stock',
            'Estimated Taxes',
            'Healthcare',
            'Opening Balance Equity',
            'Owner’s Equity',
            'Paid-in Capital or Surplus',
            'Partner Contributions',
            'Partner Distributions',
            'Partners Equity',
            'Personal Expense',
            'Personal Income',
            'Preferred Stock',
            'Retained Earnings',
            'Treasury Stock'
        ],
        incomeSheets: [
            {
                name: 'Income',
                'detailType': ['Discounts/Refunds Given', 'Non-Profit Income', 'Other Primary Income', 'Sales Product Income', 'Service/Fee Income', 'Unapplied Cash Payment Income'],
                'charts': [],
                balance: 0.00, pBalance: 0.00
            },
            {
                name: 'Cost Of Goods Sold',
                'detailType': ['Equipment-COGS', 'Labor-COGS', 'Material-COGS', 'Field Employees Workers Comp–COGS', 'Field Employees Payroll Taxes-COGS', 'Other Costs of Services', 'Shipping, Freight & Delivery'],
                balance: 0.00, pBalance: 0.00
            },
            {
                name: 'Expenses',
                'detailType': ['Advertising/Promotional', 'Auto', 'Bad Debts', 'Bank Charges', 'Charitable Contributions', 'Cost of Labor', 'Dues & Subscriptions', 'Entertainment', 'Entertainment Meals', 'Equipment Rental', 'Finance Costs', 'Insurance', 'Interest Paid', 'Legal & Professional Fees', 'Office/General Administrative Expenses', 'Other Business Expenses', 'Other Miscellaneous Service Costs', 'Payroll Expenses', 'Promotional Meals', 'Rent or Lease of Buildings', 'Repair or Maintenance', "Shipping, Freight, Delivery's", 'Supplies & Materials', 'Taxes Paid', 'Travel', 'Travel Meals', 'Unapplied Cash Bill Payment Expense', 'Utilities'],
                'charts': [],
                balance: 0.00, pBalance: 0.00
            },
            {
                name: 'Other Income',
                detailType: ['Dividend Income', 'Interest Earned', 'Other Investment Income', 'Other Miscellaneous Income', 'Tax-Exemot Interest'],
                charts: [],
                balance: 0.00, pBalance: 0.00
            },
            {
                name: 'Other Expenses',
                detailType: ['Ammortization', 'Depreciation', 'Exchange Gain or Loss', 'Gas or Fuel', 'Home Office', 'Homeowner Rental Insurance', 'Mortgage Interest Home Office', 'Other Home Office Expenses', 'Other Miscellaneous Expenses', 'Other Vehicle Expenses', 'Parking and Tolls', 'Penalties and Settlements', 'Rent and Lease Home Office', 'Repairs and Maintenance Home Office', 'Utilities Home Office', 'Vehicle', 'Vehicle Insurance', 'Vehicle Lease', 'Vehicle Loan', 'Vehicle Loan Interest', 'Vehicle Registration', 'Vehicle Repairs', 'Wash and Road Services'],
                charts: [],
                balance: 0.00, pBalance: 0.00
            }
        ],
        incomeTypes: [
            'Discounts/Refunds Given',
            'Non-Profit Income',
            'Other Primary Income',
            'Sales Product Income',
            'Service/Fee Income',
            'Unapplied Cash Payment Income',
            'Dividend Income', 'Interest Earned',
            'Other Investment Income',
            'Other Miscellaneous Income',
            'Tax-Exemot Interest',
            'Equipment-COGS',
            'Labor-COGS',
            'Material-COGS',
            'Field Employees Workers Comp–COGS',
            'Field Employees Payroll Taxes-COGS',
            'Other Costs of Services',
            'Shipping, Freight & Delivery',
            'Advertising/Promotional',
            'Auto',
            'Bad Debts',
            'Bank Charges',
            'Charitable Contributions',
            'Cost of Labor',
            'Dues & Subscriptions',
            'Entertainment',
            'Entertainment Meals',
            'Equipment Rental',
            'Finance Costs',
            'Insurance',
            'Interest Paid',
            'Legal & Professional Fees',
            'Office/General Administrative Expenses',
            'Other Business Expenses',
            'Other Miscellaneous Service Costs',
            'Payroll Expenses',
            'Promotional Meals',
            'Rent or Lease of Buildings',
            'Repair or Maintenance',
            "Shipping, Freight, Delivery's",
            'Supplies & Materials',
            'Taxes Paid', 'Travel',
            'Travel Meals',
            'Unapplied Cash Bill Payment Expense',
            'Utilities',
            'Ammortization',
            'Depreciation',
            'Exchange Gain or Loss',
            'Gas or Fuel',
            'Home Office',
            'Homeowner Rental Insurance',
            'Mortgage Interest Home Office',
            'Other Home Office Expenses',
            'Other Miscellaneous Expenses',
            'Other Vehicle Expenses',
            'Parking and Tolls',
            'Penalties and Settlements',
            'Rent and Lease Home Office',
            'Repairs and Maintenance Home Office',
            'Utilities Home Office',
            'Vehicle',
            'Vehicle Insurance',
            'Vehicle Lease',
            'Vehicle Loan',
            'Vehicle Loan Interest',
            'Vehicle Registration',
            'Vehicle Repairs',
            'Wash and Road Services'
        ],
        vendorTerms: ['Due On Receipt', 'Net 15', 'Net 30', 'Net 60', 'Other'],
        status: ['Active', 'InActive'],
        preferredAccount: ['Cash', 'Credit Card', 'Check', 'Direct Deposit', 'Checking Account'],
        reoccurringType: [
            { 'key': 'weekly', 'name': 'Weekly', 'Type': 'W', 'Num': 1 },
            { 'key': 'biweekly', 'name': 'Biweekly', 'Type': 'W', 'Num': 2 },
            { 'key': 'twicePerMonth', 'name': 'Twice Per Month', 'Type': 'M', 'Num': 2 },
            { 'key': 'fourWeeks', 'name': 'Four Weeks', 'Type': 'W', 'Num': 4 },
            { 'key': 'monthly', 'name': 'Monthly', 'Type': 'M', 'Num': 1 },
            { 'key': 'twoMonths', 'name': 'Two Months', 'Type': 'M', 'Num': 2 },
            { 'key': 'quarterly', 'name': 'Quarterly', 'Type': 'M', 'Num': 3 },
            { 'key': 'twicePerYear', 'name': 'Twice Per Year', 'Type': 'M', 'Num': 6 },
            { 'key': 'year', 'name': 'Year', 'Type': 'Y', 'Num': 1 }
        ],
        transactionModal: [
            {'name': 'Expense', 'tranType': 'Expense', 'modal': 'Vendor' },
            {'name': 'Bill', 'tranType': 'Bill', 'modal': 'Vendor'},
            {'name': 'Check', 'tranType': 'Check', 'modal': 'Vendor'},
            {'name': 'Pay Bill', 'tranType': 'PayBill', 'modal': 'Vendor'},
            {'name': 'Invoice', 'tranType': 'Invoice', 'modal': 'Customer'},
            {'name': 'Recieve Payment', 'tranType': 'ReceivePayment', 'modal': 'Customer'},
            {'name': 'Payroll Expense', 'tranType': 'PayrollExpense', 'modal': 'Employee'},
            {'name': 'Payroll Bill', 'tranType': 'PayrollBill', 'modal': 'Employee'},
            {'name': 'Payroll Check', 'tranType': 'PayrollCheck', 'modal': 'Employee'},
            {'name': 'Pay Payroll Bills', 'tranType': 'PayPayrollBill', 'modal': 'Employee'},
            {'name': 'Transfer', 'tranType': 'Transfer', 'modal': 'Other'},
            {'name': 'Journal Entry', 'tranType': 'JournalEntry', 'modal': 'Other'}
        ],
        transactionType: ['Expense', 'Bill', 'Check', 'PayBill', 'Invoice', 'ReceivePayment', 'PayrollExpense', 'Payroll Bill', 'PayrollCheck', 'PayPayrollBill', 'Transfer', 'JournalEntry'],
        JobTypePhase: ['Contract', 'Options', 'Extras'],
        reconRefrence: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF', 'GG', 'HH', 'II', 'JJ', 'KK', 'LL', 'MM', 'NN', 'OO', 'PP', 'QQ', 'RR', 'SS', 'TT', 'UU', 'VV', 'WW', 'XX', 'YY', 'ZZ'],
        reportConstant: {
            generalLedger: 'generalLedger',
            balanceSheet: 'balanceSheet',
            incomeStatus: 'incomeStatus',
            workProcess: 'workProcess'
        },
        reconReasons: [
            { name: 'Transaction in Transit', groupBy: 'Statement' },
            { name: 'Outstanding Checks', groupBy: 'Statement' },
            { name: 'Statement Errors', groupBy: 'Statement' },
            { name: 'Transactions Errors', groupBy: 'A.C.E. Transactions' }
        ],
        missingReasons: [
            { name: 'Transaction in Transit', groupBy: 'Statement' },
            { name: 'Outstanding Checks', groupBy: 'Statement' },
            { name: 'Missing Transactions', groupBy: 'A.C.E. Transactions' },
            { name: 'Interest Received', groupBy: 'A.C.E. Transactions' },
            { name: 'Fees', groupBy: 'A.C.E. Transactions' },
            { name: 'Bounced Checks', groupBy: 'A.C.E. Transactions' }
        ],
        reconcilateData: [
            { section: 'statement', label: 'Unadjusted Closing Balance', value: 0.00, refs: [] },
            { section: 'statement', label: 'Transaction in Transit', value: 0.00, refs: [] },
            { section: 'statement', label: 'Outstanding Checks', value: 0.00, refs: [] },
            { section: 'statement', label: 'Statement Errors', value: 0.00, refs: [] },

            { section: 'transaction', label: 'Unadjusted Closing Balance', value: 0.00, refs: [] },
            { section: 'transaction', label: 'Missing Transactions', value: 0.00, refs: [] },
            { section: 'transaction', label: 'Interest Received', value: 0.00, refs: [] },
            { section: 'transaction', label: 'Fees', value: 0.00, refs: [] },
            { section: 'transaction', label: 'Bounced Checks', value: 0.00, refs: [] },
            { section: 'transaction', label: 'Transactions Errors', value: 0.00, refs: [] },

            { section: 'stmtTotals', label: 'Adjusted Closing Balance', value: 0.00 },
            { section: 'tranTotals', label: 'Adjusted Closing Balance', value: 0.00 },

            { section: 'unreconsiledTotals', label: 'Unreconciled Balance', value: 0.00 }
        ],
        workInProgressHeader: [
            { key: 'name', label: 'Builders/Projects' , type: 'text'},
            { key: 'total' , label: 'Total Revenue', type: 'currency'},
            { key: 'projCost', label: 'Projected Costs', type: 'currency'},
            { key: 'projCostPercent', label: '%', type: 'perc' },
            { key: 'projGrossProfit', label: 'Projected Gross Profit', type: 'currency'},
            { key: 'projGrossProfitPercent', label: 'Projected Gross Profit %', type: 'perc'},
            { key: 'actualCosts', label: 'Actual Costs', type: 'currency'},
            { key: 'completionPercent' , label: 'Completion %', type: 'perc'},
            { key: 'profitToDate', label: 'Profit To Date', type: 'currency'},
            { key: 'amountEarned', label: 'Amount Earned', type: 'currency'},
            { key: 'totalInvoices', label: 'Total Invoices', type: 'currency'},
            { key: 'overBillings', label: 'Over Billings', type: 'currency'},
            { key: 'underBillings', label: 'Under Billings', type: 'currency'}
        ]

    }

    var documentConst = {
        roleOptions: [
            {
                'label': 'Admin',
                'id': 'admin'
            },
            {
                'label': 'Office',
                'id': 'office'
            },
            {
                'label': 'Manager',
                'id': 'manager'
            },
            {
                'label': 'Foreman',
                'id': 'foreman'
            }
        ]
    }

    angular.module('mean')
        .constant('commonConstant', commonConstant)
        .constant('generalTaskConstant', generalTaskConstant)
        .constant('message', message)
        .constant('accountingConstant', accountingConstant)
        .constant('csvExport', csvExportConstant)
        .constant('documentConst', documentConst)
})();



// WEBPACK FOOTER //
// ./constants/constant.js